import { render, staticRenderFns } from "./ViewPracticeDetailsCard.vue?vue&type=template&id=53c2f0b0&scoped=true&"
import script from "./ViewPracticeDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ViewPracticeDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./ViewPracticeDetailsCard.vue?vue&type=style&index=0&id=53c2f0b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c2f0b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBadge,VBtn,VCard,VCol,VIcon,VImg,VListItemAvatar,VRow,VSkeletonLoader,VSpacer,VTextarea})
